import { u as useRecordVisibilityChanges, k as jsxRuntimeExports } from "./doenetml-a_KitGQm.js";
import React__default, { useRef } from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-Ca2HvWV4.js";
import { a as addCommasForCompositeRanges } from "./composites-D0HuUvQk.js";
import { c as calculateValidationState, u as useSubmitActionWithDelay, a as createCheckWorkComponent } from "./useSubmitActionWithDelay-D3qGoYb4.js";
const containerBlock = React__default.memo(function Container(props) {
  let { id, SVs, children, actions, callAction } = useDoenetRenderer(props);
  const ref = useRef(null);
  useRecordVisibilityChanges(ref, callAction, actions);
  if (SVs.hidden) {
    return null;
  }
  let checkWorkComponent = null;
  const validationState = calculateValidationState(SVs);
  const { isPending, submitActionWithPending } = useSubmitActionWithDelay({
    actionKey: "submitAllAnswers",
    actions,
    callAction,
    validationState,
    justSubmitted: SVs.justSubmitted
  });
  if (actions.submitAllAnswers) {
    checkWorkComponent = createCheckWorkComponent(
      SVs,
      id,
      validationState,
      submitActionWithPending,
      true,
      isPending
    );
    if (checkWorkComponent) {
      checkWorkComponent = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: checkWorkComponent });
    }
  }
  if (SVs._compositeReplacementActiveRange) {
    children = addCommasForCompositeRanges({
      children,
      compositeReplacementActiveRange: SVs._compositeReplacementActiveRange,
      startInd: 0,
      endInd: children.length - 1
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      id,
      ref,
      style: SVs.renderInlineForListItem ? { marginTop: 0 } : void 0,
      children: [
        children,
        checkWorkComponent
      ]
    }
  );
});
export {
  containerBlock as default
};
